export const translations = {
  en: {
    // Navbar
    home: 'Home',
    aboutLeague: 'About the League',
    about: 'About',
    schedule: 'Schedule',
    scoreboard: 'Scoreboard',
    results: 'Results',
    teams: 'Teams',
    contact: 'Contact',
    adminLogin: 'Admin Login',
    adminPanel: 'Admin Panel',
    logout: 'Logout',
    privacyPolicy: 'Privacy Policy',
    termsOfUse: 'Terms of Use',
    
    // Home
    season: 'Season',
    heroTitle: "Women's Basketball League Athens",
    heroSubtitle: "Elevating women's basketball in Greece with our new amateur league. Join us for an exciting season of competition, athleticism, and community.",
    viewSchedule: 'View Schedule',
    meetTeams: 'Meet the Teams',
    upcomingGames: 'Upcoming Games',
    viewAll: 'View All Games',
    ourTeams: 'Our Teams',
    viewAllTeams: 'View All Teams',
    vs: 'VS',
    homeLabel: 'HOME',
    awayLabel: 'AWAY',
    joinCommunity: 'Join the WBLA Community',
    communityText: "Whether you're a player, fan, or supporter, there's a place for you in women's basketball in Athens.",
    getInTouch: 'Get in Touch',
    registerPlayer: 'Register as a Player',
    registerTeam: 'Register Your Team',
    joinUs: 'Register for Season 2 - 2026',
    
    // About
    aboutTitle: 'About WBLA',
    aboutSubtitle: 'Empowering women through basketball since 2026',
    ourMission: 'Our Mission',
    missionText1: 'The Women\'s Basketball League Athens (WBLA) was founded with a clear vision: although amateur, it aims to create a professional, competitive, and supportive environment for women\'s basketball in Greece.',
    missionText2: 'We believe in the power of sport to transform lives, build communities, and inspire the next generation of female athletes. Our league provides a platform for talented women to showcase their skills, compete at a high level, and grow both as athletes and individuals.',
    missionText3: 'Starting in Athens, our goal is to expand throughout Greece, bringing women\'s basketball to every corner of the country.',
    excellence: 'Excellence',
    excellenceDesc: 'We strive for the highest standards in competition and sportsmanship.',
    community: 'Community',
    communityDesc: 'Building a supportive network of players, fans, and supporters.',
    growth: 'Growth',
    growthDesc: 'Developing talent and expanding opportunities for women in basketball.',
    seasonFacts: 'Season 2 Facts',
    teamsCount: 'Teams',
    playersCount: 'Players',
    gamesCount: 'Games',
    champion: 'Champion',
    
    // Privacy Policy
    privacyTitle: 'Privacy Policy',
    privacySubtitle: 'Protection of Personal Data (GDPR)',
    
    // Terms of Use
    termsTitle: 'Terms of Use',
    termsSubtitle: 'Website Usage Terms and Conditions',
    
    // Schedule
    scheduleTitle: 'Season Schedule',
    scheduleSubtitle: 'Upcoming games for Season 1',
    week: 'Week',
    
    // Results
    resultsTitle: 'Game Results',
    resultsSubtitle: 'Completed games and scores',
    noCompletedGames: 'No completed games yet',
    final: 'Final',
    watchVideo: 'Watch the game video',
    
    // Scoreboard
    scoreboardTitle: 'Scoreboard',
    scoreboardSubtitle: 'League Standings',
    leagueStandings: 'League Standings',
    team: 'Team',
    wins: 'W',
    losses: 'L',
    gamesPlayed: 'GP',
    pointsFor: 'PF',
    pointsAgainst: 'PA',
    pointDiff: 'DIFF',
    
    // Teams
    teamsTitle: 'Our Teams',
    teamsSubtitle: 'Meet the 8 teams competing in Season 1',
    coach: 'Coach',
    players: 'Players',
    roster: 'Roster',
    age: 'Age',
    uploadLogo: 'Upload Logo',
    
    // Contact
    contactTitle: 'Contact Us',
    contactSubtitle: 'Get in touch with the WBLA team',
    leagueOffice: 'League Office',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    officeHours: 'Office Hours',
    monFri: 'Monday - Friday',
    saturday: 'Saturday',
    followUs: 'Follow Us',
    
    // Footer
    footerTagline: 'Empowering women through basketball in Athens, Greece.',
    quickLinks: 'Quick Links',
    aboutUs: 'About Us',
    legal: 'Legal',
    allRights: 'All rights reserved.',
    
    // Login
    loginTitle: 'Admin Login',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    loggingIn: 'Logging in...',
    invalidCredentials: 'Invalid credentials',
    
    // Admin
    adminTitle: 'Admin Panel',
    updateScore: 'Update Score',
    save: 'Save',
    edit: 'Edit',
    videoUrl: 'YouTube URL',
    manageTeams: 'Manage Teams',
    managePlayers: 'Manage Players',
    manageGames: 'Manage Games',
    addPlayer: 'Add Player',
    editTeam: 'Edit Team',
    editPlayer: 'Edit Player',
    editGame: 'Edit Game',
    deletePlayer: 'Delete Player',
    deleteGame: 'Delete Game',
    createGame: 'Create Game',
    jerseyNumber: 'Jersey #',
    position: 'Position',
    height: 'Height',
    cancel: 'Cancel',
    delete: 'Delete',
    create: 'Create',
    homeTeam: 'Home Team',
    awayTeam: 'Away Team',
    date: 'Date',
    time: 'Time',
    venue: 'Venue',
    week: 'Week',
    selectTeam: 'Select Team',
    confirmDelete: 'Are you sure you want to delete?',
    teamName: 'Team Name',
    coachName: 'Coach Name',
    playerName: 'Player Name',
    noPlayers: 'No players in this team',
    addNew: 'Add New',
    addTeam: 'Add Team',
    deleteTeam: 'Delete Team',
    shortName: 'Short Name (3 letters)',
    teamColor: 'Team Color',
    createTeam: 'Create Team',
    resetStats: 'Reset All Stats',
    resetStatsConfirm: 'Reset all team statistics to zero?',
    seasonSettings: 'Season Settings',
    editSeasonFacts: 'Edit Season Facts',
    
    // News
    news: 'News',
    newsTitle: 'Announcements',
    newsSubtitle: 'Latest league news',
    noAnnouncements: 'No announcements yet',
    pinned: 'Pinned',
    announcementTitle: 'Title',
    announcementContent: 'Content',
    manageAnnouncements: 'Announcements',
    createAnnouncement: 'New Announcement',
    attachments: 'Attachments',
    addAttachment: 'Add File',
    downloadPdf: 'Download PDF',
    
    // Gallery
    gallery: 'Photos',
    galleryTitle: 'Photos',
    gallerySubtitle: 'Moments from the games',
    noPhotos: 'No photos yet',
    manageGallery: 'Media',
    createAlbum: 'New Album',
    addPhoto: 'Add Photo',
    externalUrl: 'External URL',
    uploadPhoto: 'Upload Photo',
    media: 'Media',
    photos: 'Photos',
    videos: 'Videos',
    noVideos: 'No videos yet',
    addVideo: 'Add Video',
    videoTitle: 'Title',
    videoUrl: 'YouTube URL',
    videoDescription: 'Description',
    
    // MVP
    mvpTitle: 'MVP so far',
    mvpEfficiency: 'Efficiency',
    
    // Share
    share: 'Share',
    copyLink: 'Copy Link',
    linkCopied: 'Copied!',
    latestNews: 'Latest News',
    readMore: 'View all news',
    
    // Rankings
    rankings: 'Rankings',
    rankingsTitle: 'Player Rankings',
    rankingsSubtitle: 'Top performers of the season',
    topScorers: 'Top Scorers',
    topRebounders: 'Top Rebounders',
    topAssists: 'Top Assists',
    topSteals: 'Top Steals',
    topEfficiency: 'Top Efficiency',
    noRankings: 'No player statistics yet',
  },
  gr: {
    // Navbar
    home: 'Αρχική',
    aboutLeague: 'Σχετικά με το Πρωτάθλημα',
    about: 'Σχετικά',
    schedule: 'Πρόγραμμα',
    scoreboard: 'Βαθμολογία',
    results: 'Αποτελέσματα',
    teams: 'Ομάδες',
    contact: 'Επικοινωνία',
    adminLogin: 'Σύνδεση Διαχειριστή',
    adminPanel: 'Πίνακας Διαχείρισης',
    logout: 'Αποσύνδεση',
    privacyPolicy: 'Προσωπικά Δεδομένα',
    termsOfUse: 'Όροι Χρήσης',
    
    // Home
    season: 'Σεζόν',
    heroTitle: 'Γυναικείο Πρωτάθλημα Μπάσκετ Αθήνας',
    heroSubtitle: 'Αναβαθμίζουμε το γυναικείο μπάσκετ στην Ελλάδα με το νέο μας ερασιτεχνικό πρωτάθλημα. Ελάτε μαζί μας για μια συναρπαστική σεζόν ανταγωνισμού, αθλητισμού και κοινότητας.',
    viewSchedule: 'Δείτε το Πρόγραμμα',
    meetTeams: 'Γνωρίστε τις Ομάδες',
    upcomingGames: 'Επερχόμενοι Αγώνες',
    viewAll: 'Δείτε Όλους τους Αγώνες',
    ourTeams: 'Οι Ομάδες μας',
    viewAllTeams: 'Δείτε Όλες τις Ομάδες',
    vs: 'VS',
    homeLabel: 'ΕΝΤΟΣ',
    awayLabel: 'ΕΚΤΟΣ',
    joinCommunity: 'Γίνετε μέλος της κοινότητας WBLA',
    communityText: 'Είτε είστε παίκτρια, φίλαθλος ή υποστηρικτής, υπάρχει θέση για εσάς στο γυναικείο μπάσκετ της Αθήνας.',
    getInTouch: 'Επικοινωνήστε',
    registerPlayer: 'Δήλωσε συμμετοχή σαν παίκτρια',
    registerTeam: 'Δήλωσε την ομάδα σου',
    joinUs: 'Συμμετοχή για την 2η Σεζόν - 2026',
    
    // About
    aboutTitle: 'Σχετικά με το WBLA',
    aboutSubtitle: 'Ενδυναμώνουμε τις γυναίκες μέσω του μπάσκετ από το 2026',
    ourMission: 'Η Αποστολή μας',
    missionText1: 'Το Γυναικείο Πρωτάθλημα Μπάσκετ Αθήνας (WBLA) ιδρύθηκε με ένα σαφές όραμα: αν και ερασιτεχνικό, θέλει να δημιουργήσει ένα επαγγελματικό, ανταγωνιστικό και υποστηρικτικό περιβάλλον για το γυναικείο μπάσκετ στην Ελλάδα.',
    missionText2: 'Πιστεύουμε στη δύναμη του αθλητισμού να μεταμορφώνει ζωές, να χτίζει κοινότητες και να εμπνέει την επόμενη γενιά γυναικών αθλητριών. Το πρωτάθλημά μας παρέχει μια πλατφόρμα για ταλαντούχες γυναίκες να επιδείξουν τις ικανότητές τους.',
    missionText3: 'Ξεκινώντας από την Αθήνα, στόχος μας είναι να επεκταθούμε σε όλη την Ελλάδα, φέρνοντας το γυναικείο μπάσκετ σε κάθε γωνιά της χώρας.',
    excellence: 'Αριστεία',
    excellenceDesc: 'Επιδιώκουμε τα υψηλότερα πρότυπα στον ανταγωνισμό και τον αθλητισμό.',
    community: 'Κοινότητα',
    communityDesc: 'Χτίζουμε ένα υποστηρικτικό δίκτυο παικτριών, φιλάθλων και υποστηρικτών.',
    growth: 'Ανάπτυξη',
    growthDesc: 'Αναπτύσσουμε ταλέντα και διευρύνουμε τις ευκαιρίες για τις γυναίκες στο μπάσκετ.',
    seasonFacts: 'Στοιχεία Σεζόν 2',
    teamsCount: 'Ομάδες',
    playersCount: 'Παίκτριες',
    gamesCount: 'Αγώνες',
    champion: 'Πρωταθλητής',
    
    // Privacy Policy
    privacyTitle: 'Προσωπικά Δεδομένα',
    privacySubtitle: 'Πολιτική Προστασίας Προσωπικών Δεδομένων (GDPR)',
    
    // Terms of Use
    termsTitle: 'Όροι Χρήσης',
    termsSubtitle: 'Όροι και Προϋποθέσεις Χρήσης Ιστοσελίδας',
    
    // Schedule
    scheduleTitle: 'Πρόγραμμα Αγώνων',
    scheduleSubtitle: 'Επερχόμενοι αγώνες της Σεζόν 1',
    week: 'Εβδομάδα',
    
    // Results
    resultsTitle: 'Αποτελέσματα Αγώνων',
    resultsSubtitle: 'Ολοκληρωμένοι αγώνες και σκορ',
    noCompletedGames: 'Δεν υπάρχουν ολοκληρωμένοι αγώνες ακόμα',
    final: 'Τελικό',
    watchVideo: 'Παρακολουθήστε το βίντεο του αγώνα',
    
    // Scoreboard
    scoreboardTitle: 'Βαθμολογία',
    scoreboardSubtitle: 'Κατάταξη Πρωταθλήματος',
    leagueStandings: 'Βαθμολογία Πρωταθλήματος',
    team: 'Ομάδα',
    wins: 'Ν',
    losses: 'Η',
    gamesPlayed: 'ΑΓ',
    pointsFor: 'Π+',
    pointsAgainst: 'Π-',
    pointDiff: 'ΔΙΑΦ',
    
    // Teams
    teamsTitle: 'Οι Ομάδες μας',
    teamsSubtitle: 'Γνωρίστε τις 8 ομάδες που αγωνίζονται στη Σεζόν 1',
    coach: 'Προπονητής',
    players: 'Παίκτριες',
    roster: 'Ρόστερ',
    age: 'Ηλικία',
    uploadLogo: 'Ανέβασμα Λογότυπου',
    
    // Contact
    contactTitle: 'Επικοινωνία',
    contactSubtitle: 'Επικοινωνήστε με την ομάδα του WBLA',
    leagueOffice: 'Γραφεία Διοργάνωσης',
    address: 'Διεύθυνση',
    phone: 'Τηλέφωνο',
    email: 'Email',
    officeHours: 'Ώρες Λειτουργίας',
    monFri: 'Δευτέρα - Παρασκευή',
    saturday: 'Σάββατο',
    followUs: 'Ακολουθήστε μας',
    
    // Footer
    footerTagline: 'Ενδυναμώνουμε τις γυναίκες μέσω του μπάσκετ στην Αθήνα, Ελλάδα.',
    quickLinks: 'Γρήγοροι Σύνδεσμοι',
    aboutUs: 'Σχετικά με εμάς',
    legal: 'Νομικά',
    allRights: 'Με επιφύλαξη παντός δικαιώματος.',
    
    // Login
    loginTitle: 'Σύνδεση Διαχειριστή',
    username: 'Όνομα χρήστη',
    password: 'Κωδικός',
    login: 'Σύνδεση',
    loggingIn: 'Σύνδεση...',
    invalidCredentials: 'Λάθος στοιχεία',
    
    // Admin
    adminTitle: 'Πίνακας Διαχείρισης',
    updateScore: 'Ενημέρωση Σκορ',
    save: 'Αποθήκευση',
    edit: 'Επεξεργασία',
    videoUrl: 'YouTube URL',
    manageTeams: 'Διαχείριση Ομάδων',
    managePlayers: 'Διαχείριση Παικτριών',
    manageGames: 'Διαχείριση Αγώνων',
    addPlayer: 'Προσθήκη Παίκτριας',
    editTeam: 'Επεξεργασία Ομάδας',
    editPlayer: 'Επεξεργασία Παίκτριας',
    editGame: 'Επεξεργασία Αγώνα',
    deletePlayer: 'Διαγραφή Παίκτριας',
    deleteGame: 'Διαγραφή Αγώνα',
    createGame: 'Δημιουργία Αγώνα',
    jerseyNumber: 'Αριθμός',
    position: 'Θέση',
    height: 'Ύψος',
    cancel: 'Ακύρωση',
    delete: 'Διαγραφή',
    create: 'Δημιουργία',
    homeTeam: 'Γηπεδούχος',
    awayTeam: 'Φιλοξενούμενος',
    date: 'Ημερομηνία',
    time: 'Ώρα',
    venue: 'Γήπεδο',
    week: 'Εβδομάδα',
    selectTeam: 'Επιλέξτε Ομάδα',
    confirmDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε;',
    teamName: 'Όνομα Ομάδας',
    coachName: 'Όνομα Προπονητή',
    playerName: 'Όνομα Παίκτριας',
    noPlayers: 'Δεν υπάρχουν παίκτριες σε αυτή την ομάδα',
    addNew: 'Προσθήκη',
    addTeam: 'Προσθήκη Ομάδας',
    deleteTeam: 'Διαγραφή Ομάδας',
    shortName: 'Συντομογραφία (3 γράμματα)',
    teamColor: 'Χρώμα Ομάδας',
    createTeam: 'Δημιουργία Ομάδας',
    resetStats: 'Μηδενισμός Στατιστικών',
    resetStatsConfirm: 'Μηδενισμός όλων των στατιστικών ομάδων;',
    seasonSettings: 'Ρυθμίσεις Σεζόν',
    editSeasonFacts: 'Επεξεργασία Στοιχείων Σεζόν',
    
    // News
    news: 'Νέα',
    newsTitle: 'Ανακοινώσεις',
    newsSubtitle: 'Τα τελευταία νέα του πρωταθλήματος',
    noAnnouncements: 'Δεν υπάρχουν ανακοινώσεις',
    pinned: 'Καρφιτσωμένο',
    announcementTitle: 'Τίτλος',
    announcementContent: 'Περιεχόμενο',
    manageAnnouncements: 'Ανακοινώσεις',
    createAnnouncement: 'Νέα Ανακοίνωση',
    attachments: 'Συνημμένα',
    addAttachment: 'Προσθήκη Αρχείου',
    downloadPdf: 'Λήψη PDF',
    
    // Gallery
    gallery: 'Φωτογραφίες',
    galleryTitle: 'Φωτογραφίες',
    gallerySubtitle: 'Στιγμές από τους αγώνες',
    noPhotos: 'Δεν υπάρχουν φωτογραφίες',
    manageGallery: 'Media',
    createAlbum: 'Νέο Άλμπουμ',
    addPhoto: 'Προσθήκη Φωτογραφίας',
    externalUrl: 'Εξωτερικό URL',
    uploadPhoto: 'Ανέβασμα Φωτογραφίας',
    media: 'Media',
    photos: 'Φωτογραφίες',
    videos: 'Βίντεο',
    noVideos: 'Δεν υπάρχουν βίντεο',
    addVideo: 'Προσθήκη Βίντεο',
    videoTitle: 'Τίτλος',
    videoUrl: 'YouTube URL',
    videoDescription: 'Περιγραφή',
    
    // MVP
    mvpTitle: 'MVP μέχρι στιγμής',
    mvpEfficiency: 'Αποδοτικότητα',
    
    // Share
    share: 'Κοινοποίηση',
    copyLink: 'Αντιγραφή Link',
    linkCopied: 'Αντιγράφηκε!',
    latestNews: 'Τελευταία Νέα',
    readMore: 'Δείτε όλα τα νέα',
    
    // Rankings
    rankings: 'Κατάταξη',
    rankingsTitle: 'Κατάταξη Παικτριών',
    rankingsSubtitle: 'Οι κορυφαίες της σεζόν',
    topScorers: 'Top Scorers',
    topRebounders: 'Top Rebounders',
    topAssists: 'Top Ασίστ',
    topSteals: 'Top Κλεψίματα',
    topEfficiency: 'Top Αποδοτικότητα',
    noRankings: 'Δεν υπάρχουν στατιστικά παικτριών ακόμα',
  }
};

